import React from 'react';
import Footer from '../components/Footer';

const EmailPolicy = () => {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 1, padding: '40px 20px', maxWidth: '900px', margin: '0 auto' }}>
        <h1 style={{ marginBottom: '8px', color: '#1a1a2e' }}>Email Policy</h1>
        <p style={{ color: '#666', marginBottom: '40px' }}>
          Effective Date: March 1, 2025 | Last Updated: January 15, 2026
        </p>

        <div style={{ lineHeight: '1.8', color: '#333' }}>
          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>1. Overview</h2>
            <p>
              ShowingBooker LLC ("ShowingBooker," "we," "us," or "our") uses email to communicate
              with our users regarding property showings, tenant notifications, compliance
              documentation, and service updates. This Email Policy explains how we collect,
              use, and manage email communications.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>2. Types of Emails We Send</h2>
            <p>
              By creating a ShowingBooker account, you may receive the following types of emails:
            </p>
            <h3 style={{ fontSize: '1.1rem', marginTop: '16px', marginBottom: '8px' }}>Transactional Emails</h3>
            <ul style={{ paddingLeft: '24px' }}>
              <li>Account verification and password reset</li>
              <li>Showing confirmations and reminders</li>
              <li>24/48-hour tenant notification notices</li>
              <li>Booking confirmations and receipts</li>
              <li>Compliance report deliveries</li>
              <li>Security alerts and account notifications</li>
            </ul>

            <h3 style={{ fontSize: '1.1rem', marginTop: '16px', marginBottom: '8px' }}>Service Emails</h3>
            <ul style={{ paddingLeft: '24px' }}>
              <li>Important service updates and changes</li>
              <li>Policy updates and legal notices</li>
              <li>System maintenance notifications</li>
            </ul>

            <h3 style={{ fontSize: '1.1rem', marginTop: '16px', marginBottom: '8px' }}>Marketing Emails (Opt-in Only)</h3>
            <ul style={{ paddingLeft: '24px' }}>
              <li>Product updates and new features</li>
              <li>Tips and best practices</li>
              <li>Promotional offers</li>
            </ul>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>3. Consent</h2>
            <p>
              By creating an account with ShowingBooker, you consent to receive transactional
              and service emails necessary for the operation of your account. Marketing emails
              require separate opt-in consent and can be unsubscribed at any time.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>4. Opting Out / Unsubscribing</h2>
            <p>You can manage your email preferences as follows:</p>
            <ul style={{ marginTop: '12px', paddingLeft: '24px' }}>
              <li><strong>Marketing Emails:</strong> Click the "Unsubscribe" link at the bottom of any marketing email, or update your preferences in your account settings.</li>
              <li><strong>Service Updates:</strong> Can be managed through account notification settings.</li>
              <li><strong>Transactional Emails:</strong> These are essential for account operation and cannot be fully disabled while your account is active. This includes compliance notifications required by law.</li>
            </ul>
            <p style={{ marginTop: '12px' }}>
              <strong>Note:</strong> Tenant notification emails are part of the legal compliance process
              and may be required for proper documentation. Disabling these may affect compliance records.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>5. Email Frequency</h2>
            <p>
              Email frequency depends on your activity and preferences:
            </p>
            <ul style={{ marginTop: '12px', paddingLeft: '24px' }}>
              <li>Showing notifications: Per scheduled showing</li>
              <li>Compliance documentation: As generated</li>
              <li>Marketing emails: No more than 2 per week (if opted in)</li>
              <li>Account alerts: As needed</li>
            </ul>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>6. Legal Compliance Emails</h2>
            <p>
              For tenant-occupied properties, ShowingBooker sends email notifications as part of
              the legal compliance process. These emails serve as documented proof of notification
              delivery and are stored as part of your compliance audit trail. Features include:
            </p>
            <ul style={{ marginTop: '12px', paddingLeft: '24px' }}>
              <li>Timestamped delivery records</li>
              <li>Read receipts (where available)</li>
              <li>PDF attachments of formal notices</li>
              <li>Permanent storage for legal records</li>
            </ul>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>7. Anti-Spam Compliance</h2>
            <p>
              ShowingBooker complies with the CAN-SPAM Act and other applicable anti-spam laws.
              All marketing emails include:
            </p>
            <ul style={{ marginTop: '12px', paddingLeft: '24px' }}>
              <li>Clear identification of the sender</li>
              <li>Accurate subject lines</li>
              <li>Our physical mailing address</li>
              <li>Easy opt-out mechanism</li>
              <li>Prompt processing of unsubscribe requests (within 10 business days)</li>
            </ul>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>8. Email Security</h2>
            <p>
              We implement security measures to protect email communications:
            </p>
            <ul style={{ marginTop: '12px', paddingLeft: '24px' }}>
              <li>TLS encryption for email transmission</li>
              <li>SPF, DKIM, and DMARC authentication</li>
              <li>Secure storage of email records</li>
            </ul>
            <p style={{ marginTop: '12px' }}>
              We will never ask for your password, credit card number, or other sensitive
              information via email. If you receive such a request, please report it immediately.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>9. Data Retention</h2>
            <p>
              Email records related to compliance notifications are retained for a minimum of
              7 years to meet legal documentation requirements. Marketing email preferences
              and history are retained while your account is active and for 30 days after
              account deletion.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>10. Changes to This Policy</h2>
            <p>
              We may update this Email Policy from time to time. Changes will be posted on this
              page with an updated "Last Updated" date. Material changes will be communicated
              via email to active users.
            </p>
          </section>

          <section style={{ marginBottom: '32px', padding: '20px', background: '#f8f9fa', borderRadius: '8px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>Contact Information</h2>
            <p>
              For questions about this policy or email communications:<br /><br />
              <strong>ShowingBooker LLC</strong><br />
              26565 Agoura Road, Suite 200<br />
              Calabasas, CA 91302 USA<br />
              Email: david@codexdeus.com
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default EmailPolicy;
